// SidebarItems.jsx
import {
  Book,
  Database,
  Clipboard,
  ClipboardList,
  FileCheck2,
  FileMinus,
  FileText,
  Settings,
  TriangleAlert,
  User,
  UserX,
  Users,
  XCircle,
} from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useProfile } from '../../Contexts/ProfileContext';

type SidebarItem = {
  name: string;
  icon: JSX.Element;
  link: string;
};

type SidebarMenus = {
  super_admin: SidebarItem[];
  shift_supervisor: SidebarItem[];
  responsible_person: SidebarItem[];
  appointed_operator: SidebarItem[];
  hot_work_monitor: SidebarItem[];
  system_engineer: SidebarItem[];
  section_head: SidebarItem[];
  technical_manager: SidebarItem[];
  operation_manager: SidebarItem[];
  planner: SidebarItem[];
  technical_support_officer: SidebarItem[];
  requestor: SidebarItem[];
  maintenance_manager: SidebarItem[];
  shift_assistant: SidebarItem[];
  shift_trainee: SidebarItem[];
};

interface RootState {
  user: {
    role: keyof SidebarMenus;
  };
}

// 👇 role-based menu definitions
const sidebarMenus = {
  super_admin: [
    { name: 'ShiftLogbook', icon: <Book size={30} />, link: '/ShiftLogbook' },
    { name: 'TemporaryOperatingInstruction', icon: <FileMinus size={30} />, link: '/TemporaryOperatingInstruction' },
    { name: 'OperatingInstruction', icon: <FileText size={30} />, link: '/OperatingInstruction' },
    { name: 'OutageRequisition', icon: <XCircle size={30} />, link: '/OutageRequisition' },
    { name: 'SpecificInstruction', icon: <FileCheck2 size={30} />, link: '/SpecificInstruction' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
    { name: 'Users', icon: <User size={30} />, link: '/Users' },
    { name: 'Master', icon: <Database size={30} />, link: '/master' },
    { name: 'HVWorkPermits', icon: <ClipboardList size={30} />, link: '/HVworkPermits' },
    { name: 'PlantSafetyRegulation', icon: <Clipboard size={30} />, link: '/PlantSafetyRegulation' },
    { name: 'HotWorkApproval', icon: <TriangleAlert size={30} />, link: '/HotWorkApproval' },
    { name: 'LeaveRosterManagement', icon: <UserX size={30} />, link: '/LeaveRoster' },
    { name: 'ShiftRosterManagement', icon: <Users size={30} />, link: '/ShiftRoster' },
  ],
  shift_supervisor: [
    { name: 'ShiftLogbook', icon: <Book size={30} />, link: '/ShiftLogbook' },
    { name: 'TemporaryOperatingInstruction', icon: <FileMinus size={30} />, link: '/TemporaryOperatingInstruction' },
    { name: 'OperatingInstruction', icon: <FileText size={30} />, link: '/OperatingInstruction' },
    { name: 'OutageRequisition', icon: <XCircle size={30} />, link: '/OutageRequisition' },
    { name: 'SpecificInstruction', icon: <FileCheck2 size={30} />, link: '/SpecificInstruction' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'ShiftRosterManagement', icon: <Users size={30} />, link: '/ShiftRoster' },
    { name: 'LeaveRosterManagement', icon: <UserX size={30} />, link: '/LeaveRoster' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  responsible_person: [
    { name: 'HVWorkPermits', icon: <ClipboardList size={30} />, link: '/HVworkPermits' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  responsible_person_lv: [
    { name: 'PlantSafetyRegulation', icon: <Clipboard size={30} />, link: '/PlantSafetyRegulation' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  appointed_operator: [
    { name: 'HVWorkPermits', icon: <ClipboardList size={30} />, link: '/HVworkPermits' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  appointed_person_hwa: [
    { name: 'HotWorkApproval', icon: <TriangleAlert size={30} />, link: '/HotWorkApproval' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  responsible_person_hwa: [
    { name: 'HotWorkApproval', icon: <TriangleAlert size={30} />, link: '/HotWorkApproval' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  hot_work_monitor: [
    { name: 'HotWorkApproval', icon: <TriangleAlert size={30} />, link: '/HotWorkApproval' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  technician: [
    { name: 'HotWorkApproval', icon: <TriangleAlert size={30} />, link: '/HotWorkApproval' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  system_engineer: [
    { name: 'TemporaryOperatingInstruction', icon: <FileMinus size={30} />, link: '/TemporaryOperatingInstruction' },
    { name: 'SpecificInstruction', icon: <FileCheck2 size={30} />, link: '/SpecificInstruction' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  section_head: [
    { name: 'TemporaryOperatingInstruction', icon: <FileMinus size={30} />, link: '/TemporaryOperatingInstruction' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  technical_manager: [
    { name: 'TemporaryOperatingInstruction', icon: <FileMinus size={30} />, link: '/TemporaryOperatingInstruction' },
    { name: 'OutageRequisition', icon: <XCircle size={30} />, link: '/OutageRequisition' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  operation_manager: [
    { name: 'TemporaryOperatingInstruction', icon: <FileMinus size={30} />, link: '/TemporaryOperatingInstruction' },
    { name: 'OperatingInstruction', icon: <FileText size={30} />, link: '/OperatingInstruction' },
    { name: 'SpecificInstruction', icon: <FileCheck2 size={30} />, link: '/SpecificInstruction' },
    { name: 'OutageRequisition', icon: <XCircle size={30} />, link: '/OutageRequisition' },
    { name: 'ShiftRosterManagement', icon: <Users size={30} />, link: '/ShiftRoster' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'LeaveRosterManagement', icon: <UserX size={30} />, link: '/LeaveRoster' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  planner: [
    { name: 'OutageRequisition', icon: <XCircle size={30} />, link: '/OutageRequisition' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  senior_planner: [
    { name: 'OutageRequisition', icon: <XCircle size={30} />, link: '/OutageRequisition' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  technical_support_officer: [
    { name: 'OperatingInstruction', icon: <FileText size={30} />, link: '/OperatingInstruction' },
    { name: 'OutageRequisition', icon: <XCircle size={30} />, link: '/OutageRequisition' },
    { name: 'SpecificInstruction', icon: <FileCheck2 size={30} />, link: '/SpecificInstruction' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  requestor: [
    { name: 'OutageRequisition', icon: <XCircle size={30} />, link: '/OutageRequisition' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  maintenance_manager: [
    { name: 'OutageRequisition', icon: <XCircle size={30} />, link: '/OutageRequisition' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  appointed_person_lv: [
    { name: 'PlantSafetyRegulation', icon: <Clipboard size={30} />, link: '/PlantSafetyRegulation' },
    // { name: 'Reports', icon: <FileSpreadsheet size={30} />, link: '/Report' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  shift_assistant: [
    { name: 'ShiftLogbook', icon: <Book size={30} />, link: '/ShiftLogbook' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
  shift_trainee: [
    { name: 'ShiftLogbook', icon: <Book size={30} />, link: '/ShiftLogbook' },
    { name: 'Settings', icon: <Settings size={30} />, link: '/settings/user-info' },
  ],
};

const SidebarItems = () => {
  const location = useLocation();
  const profile = useProfile();

  if (!profile) {
    return null;
  }

  const role = profile.role;

  const menuItems = sidebarMenus[role] || [];

  return (
    <div className="h-screen bg-[#143d7d] flex flex-col items-center py-4 space-y-6 mt-45">
      {menuItems.map((item) => {
        const isActive = item.name === 'Settings' ? location.pathname.startsWith('/settings') : location.pathname.startsWith(item.link);
        return (
          <div key={item.name} className="relative group">
            {isActive && <span className="absolute left-[-16px] top-1/2 -translate-y-1/2 w-1.5 h-4 rounded bg-red-500"></span>}

            <Link
              to={item.link === '/settings' ? '/settings/user-info' : item.link}
              className={`flex items-center justify-center w-full text-white ${isActive ? 'opacity-100' : 'opacity-40 text-blue-300'}`}
            >
              {item.icon}
              {/* </div> */}
            </Link>

            {/* Tooltip */}
            <div
              className="
                absolute left-[60px] top-1/2 -translate-y-1/2
                opacity-0 group-hover:opacity-100
                transition-opacity duration-200
                pointer-events-none
                
                bg-[#1e293b]
                text-white text-xs font-medium
                px-2.5 py-1
                rounded
                shadow-lg
                whitespace-nowrap
                z-50
                
                before:content-['']
                before:absolute
                before:right-full
                before:top-1/2
                before:-translate-y-1/2
                before:border-[5px]
                before:border-transparent
                before:border-r-[#1e293b]
              "
            >
              {item.name.replace(/([A-Z])/g, ' $1').trim()}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SidebarItems;
